import { useParams } from 'react-router-dom'
import { useAllCheckpointsState } from 'screens/Admin/ProjectCheckpoints/hooks/useAllCheckpointsState'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import ThreeDotsLoader from 'shared/Loaders/ThreeDotsLoader'
import CheckResultsTable from '../../components/CheckResultsTable'

const CheckpointInspectionCheckResultsPage = () => {
  const params = useParams()
  const checkpointId = params.id
  const { checkpointsMap, loading: checkpointsLoading } = useAllCheckpointsState()
  const checkpoint = checkpointsMap[checkpointId]

  if (!checkpoint || checkpointsLoading) {
    return (
      <div className='flex-page-center'>
        <ThreeDotsLoader />
      </div>
    )
  }

  return (
    <TopNavigationLayoutPageContent type='defaultWithBackButton'>
      <div className='flex-lines'>
        <div>
          <h2 className='text--heading-h4'>Сданые работы</h2>
          <p className='text--body-s' style={{ marginTop: '8px' }}>
            {checkpoint?.name}
          </p>
        </div>
      </div>
      <CheckResultsTable checkpointId={checkpointId} />
    </TopNavigationLayoutPageContent>
  )
}

export default CheckpointInspectionCheckResultsPage
